import { useEffect } from "react";
import Layout from "../components/layout/Layout";
import { useNavigate } from "react-router-dom";
import { useInvoice } from "../hooks/useInvoice";
import InvoiceDetail from "./InvoiceDetail";
import PaymentMethod from "./PaymentMethod";

function PaymentOptions() {
  const navigate = useNavigate();
  const { getInvoice, invoice } = useInvoice();

  useEffect(() => {
    const invoice_id = window.location.pathname.split("/")[1];
    if (!invoice) {
      getInvoice(invoice_id).catch((err) => {
        navigate("/not-found", {
          replace: true,
          state: { error: err.response.data?.message || err.message }
        });
      });
    }
  }, [getInvoice, navigate, invoice]);

  return (
    <Layout
      secondHalf={{
        content: <PaymentMethod />
      }}
    >
      <InvoiceDetail />
    </Layout>
  );
}

export default PaymentOptions;
